import { ACTIVATION_SELECT_ENABLE, ACTIVATION_ENABLE } from "./ItemMyStatBase"


export class ReqUmpireList {
    constructor({ start, limit, ump_name = "", ump_activation = ACTIVATION_SELECT_ENABLE }) {
        this.start = start
        this.limit = limit
        this.ump_name = ump_name
        this.ump_activation = ump_activation
    }

    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.ump_name = jsonData.ump_name || ""
        this.ump_activation = jsonData.ump_activation || ACTIVATION_SELECT_ENABLE
    }

    get_ump_activation() {
        return this.ump_activation === 1 ? true : false
    }
}

export class ReqUmpireDetail {
    constructor({ump_id}){
        this.ump_id = ump_id
    }
    fromJson(jsonData){
        this.ump_id = jsonData.ump_id
    }
}

export class RespUmpire {
    constructor({ump_id, ump_name, ump_name_eng, ump_DOB, ump_activation, ump_last_change, ump_note, ump_pic_profile, ump_pic_profile_auth, ump_pic_profile_date, ump_pic_game, ump_pic_game_auth, ump_pic_game_date}){
        this.ump_id = ump_id 
        this.ump_name = ump_name 
        this.ump_name_eng = ump_name_eng 
        this.ump_DOB = ump_DOB 
        this.ump_activation = ump_activation 
        this.ump_last_change = ump_last_change 
        this.ump_note = ump_note
        this.ump_pic_profile = ump_pic_profile 
        this.ump_pic_profile_auth = ump_pic_profile_auth
        this.ump_pic_profile_date = ump_pic_profile_date
        this.ump_pic_game = ump_pic_game 
        this.ump_pic_game_auth = ump_pic_game_auth
        this.ump_pic_game_date = ump_pic_game_date
    }

    fromJson(jsonData){
        this.id = jsonData._id
        this.ump_id = jsonData.ump_id 
        this.ump_name = jsonData.ump_name 
        this.ump_name_eng = jsonData.ump_name_eng 
        this.ump_DOB = jsonData.ump_DOB 
        this.ump_activation = jsonData.ump_activation
        this.ump_last_change = jsonData.ump_last_change 
        this.ump_note = jsonData.ump_note
        this.ump_pic_profile = jsonData.ump_pic_profile 
        this.ump_pic_profile_auth = jsonData.ump_pic_profile_auth
        this.ump_pic_profile_date = jsonData.ump_pic_profile_date
        this.ump_pic_game = jsonData.ump_pic_game 
        this.ump_pic_game_auth = jsonData.ump_pic_game_auth
        this.ump_pic_game_date = jsonData.ump_pic_game_date
    }
}